import React, { useState, useEffect } from 'react';

// A wrapper component that forces re-renders by changing a simple state value
export const ForceRefreshWrapper = ({ children, refreshTrigger }) => {
    const [forceRender, setForceRender] = useState(0);
    
    useEffect(() => {
        // Force a re-render whenever the refreshTrigger changes
        setForceRender(prev => prev + 1);
        // console.log('🔄 ForceRefreshWrapper: Triggering re-render', forceRender + 1);
    }, [refreshTrigger]);
    
    return (
        <div key={`force-refresh-${forceRender}-${refreshTrigger}`}>
            {children}
        </div>
    );
};
